export const CAMPAIGN_CONTACT_FILTERS = {
  all: 'all',
  waiting: 'waiting',
  heldByCap: 'heldByCap',
  inSequence: 'inSequence',
  replied: 'replied',
  booked: 'booked',
  noResponse: 'noResponse',
  failed: 'failed',
  optedOut: 'optedOut',
} as const

export type CampaignContactFilter =
  (typeof CAMPAIGN_CONTACT_FILTERS)[keyof typeof CAMPAIGN_CONTACT_FILTERS]

export const CAMPAIGN_CONTACT_FILTER_ORDER: readonly CampaignContactFilter[] = [
  CAMPAIGN_CONTACT_FILTERS.all,
  CAMPAIGN_CONTACT_FILTERS.waiting,
  CAMPAIGN_CONTACT_FILTERS.heldByCap,
  CAMPAIGN_CONTACT_FILTERS.inSequence,
  CAMPAIGN_CONTACT_FILTERS.replied,
  CAMPAIGN_CONTACT_FILTERS.booked,
  CAMPAIGN_CONTACT_FILTERS.noResponse,
  CAMPAIGN_CONTACT_FILTERS.failed,
  CAMPAIGN_CONTACT_FILTERS.optedOut,
]

/**
 * Two chips describe work waiting on a person rather than a state the sequence
 * reached, so they carry the alert ink even when they are not selected.
 */
export const CAMPAIGN_CONTACT_ALERT_FILTERS: readonly CampaignContactFilter[] =
  [CAMPAIGN_CONTACT_FILTERS.waiting, CAMPAIGN_CONTACT_FILTERS.heldByCap]

export function campaignContactFilterLabelKey(
  filter: CampaignContactFilter,
): string {
  return `campaigns.contact.filters.${filter}`
}
